<template>

            <div class="col-md-6 col-xl-4">                       
              <div class="card">
                <div class="card-body">
                  <div class="media align-items-center"><img :src="imageval" class="avatar avatar-xl mr-3" />
                    <div class="media-body overflow-hidden">
                      <h5 class="card-text mb-0">{{name}}</h5>
                      <p class="card-text text-uppercase">{{city}}</p>
                      <p class="card-text">
                         
                        {{email}}<br><abbr title="Phone">P:  </abbr>{{phone}}
                      </p>
                    </div>
                  </div>
                      <a href="./#/customer-profile" class="tile-link"></a>
                </div>
              </div>
            </div>       

</template>

<script>

export default {
  name: 'customer_card',
  props: {
     name: String,
     city: String,
     imageval: String,
     email : String,
     phone : String
   },
  data () {
    return {
               
    }
  },
methods: {
     

  },
beforeMount : function() {

    
},
mounted : function () {

}   
                
}


</script>

<style scoped>



</style>



// WEBPACK FOOTER //
// src/components/supportcomp/customer_card.vue